import styled, { css } from 'styled-components';

import { media } from '@theme/media';

export const Container = styled.div<{ hasSpacingTop: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  &:not(:first-child) {
    margin-top: ${({ hasSpacingTop }) => (hasSpacingTop ? '100px' : '0')};
  }

  ${media.desktop} {
    grid-template-columns: 1fr 1fr 1fr;

    &:not(:first-child) {
      margin-top: ${({ hasSpacingTop }) => (hasSpacingTop ? '150px' : '0')};
    }
  }
`;

export const imageStyles = css`
  height: calc(50vw - 30px);
  max-width: 100%;

  ${media.tablet} {
    height: calc(33.333vw - 40px - 15px);
  }
`;
